import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import Overlay from '../Miscelania/Overlay';

import InputMask from 'react-input-mask';
import Select from 'react-select';

import { Modal } from 'react-bootstrap';

class PaymentHourEditModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      modal: false,
      loaded: 0,
      ignores_debts: 1,
      certification_supplier_id: '',
      training: '',
      date_start: '',
      date_finish: '',
      certification: '',
      supplier: '',
      hour_value: '',
      staff: '',
      hour_value: '',
      hours_paid: '',
      double_paid: "0,00",
      pnf_paid: "0,00",
      hours_total: '',
      supplier_id: '',
      certification_id: '',
      payment_editions: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);

    this.editPayment = this.editPayment.bind(this);
  }
  
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleChangeHour (name, event) {
    var change = {};
    var valido = /^[\d,.]+$/.test(event.target.value);
    if (event.target.value === "" || valido === true) {
      var self = this;
      change[name] = event.target.value
      this.setState(change);
      window.setTimeout(function(){ 
        self.handleChangeHourTotal();
      }, 200);
    }
  }

  handleChangeHourTotal (name, event) {
    var hour_value = this.state.hour_value;

    if (this.state.hours_paid) {
      var hours_paid = parseFloat(this.state.hours_paid.replace(',', '.'));
    }
    if (this.state.pnf_paid) {
      var pnf_paid = parseFloat(this.state.pnf_paid.replace(',', '.'));
    }
    if (this.state.double_paid) {
      var double_paid = parseFloat(this.state.double_paid.replace(',', '.'));
    }

    if (isNaN(hours_paid)) {
      hours_paid = 0;
    }
    if (isNaN(pnf_paid)) {
      pnf_paid = 0;
    }
    if (isNaN(double_paid)) {
      double_paid = 0;
    }
    if (isNaN(hour_value)) {
      hour_value = 0;
    }
    
    var addition = pnf_paid + hours_paid + double_paid;
    var total = addition * hour_value;
    this.setState({hours_total: total.toFixed(2)});
  }
  
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  //LM
  componentWillReceiveProps(newProps) {
    if (newProps.modal_props === true) {
      this.setState({ modal: true });
      if(typeof newProps.data_payment_hour.id !== 'undefined') {
        this.setState({
          payment_editions: newProps.data_payment_hour.payment_editions,
          training: newProps.data_payment_hour.training,
          date_start: newProps.data_payment_hour.date_start_str,
          date_finish: newProps.data_payment_hour.date_finish_str,
          certification: newProps.data_payment_hour.certification,
          supplier: newProps.data_payment_hour.supplier,
          certification_supplier: newProps.data_payment_hour.certification_supplier,
          staff: newProps.data_payment_hour.staff,
          hour_value: newProps.data_payment_hour.hour_value,
          hours_paid: newProps.data_payment_hour.hours_paid_value_str,
          double_paid: newProps.data_payment_hour.double_paid_str,
          pnf_paid: newProps.data_payment_hour.pnf_paid_str,
          hours_total: newProps.data_payment_hour.hours_total,
          ignores_debts: newProps.data_payment_hour.ignores_debts,
          justification: newProps.data_payment_hour.justification,
          observation: newProps.data_payment_hour.observation,
          id: newProps.data_payment_hour.id,
        });
      }
    }
  }

  // Fetch salvando a edição
  editPayment(event) {
    event.preventDefault();
    var datasave = {
      payment_type: 'hours',
      hours_paid: this.state.hours_paid,
      double_paid: this.state.double_paid,
      pnf_paid: this.state.pnf_paid,
      hours_total: this.state.hours_total,
      ignores_debts: this.state.ignores_debts,
      justification: this.state.justification,
      observation: this.state.observation,
      id: this.state.id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/pagamento', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.setState({ modal: false });
        self.props.refreshTable(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
      <div>
        <RequestApi ref={'request_api'} />
        <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
        <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
          <Modal.Header>
            <h4 className="pull-left">Editar pagamento</h4>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
            <i className="fa fa-fw fa-close"></i></button>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={this.editPayment}>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Nome do Treinamento:</label>
                    <input type="text" name="training" className="form-control" placeholder="" value={this.state.training} disabled="disabled" onChange={this.handleChange.bind(this, 'training')} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Aula:</label>
                    <input type="text" name="certification" className="form-control" placeholder="" value={this.state.certification} disabled="disabled" onChange={this.handleChange.bind(this, 'certification')} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Data inicial:</label>
                    <InputMask value={this.state.date_start} disabled="disabled" maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Data final:</label>
                    <InputMask value={this.state.date_finish} disabled="disabled" maskChar={null} name="date_finish" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="" />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Local:</label>
                    <input type="text" name="certification_supplier" className="form-control" placeholder="" value={this.state.certification_supplier} disabled="disabled" onChange={this.handleChange.bind(this, 'certification_supplier')} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Tripulante:</label>
                    <input type="text" name="staff" className="form-control" placeholder="" value={this.state.staff} disabled="disabled" onChange={this.handleChange.bind(this, 'staff')} />
                  </div>
                </div>
              </div>  
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Horas pagas:</label>
                    <input type="text" required value={this.state.hours_paid} name="hours_paid" className="form-control" onChange={this.handleChangeHour.bind(this, 'hours_paid')} placeholder="" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Horas PNF pagas:</label>
                    <input type="text" value={this.state.pnf_paid} name="pnf_paid" className="form-control" onChange={this.handleChangeHour.bind(this, 'pnf_paid')} placeholder="" />
                  </div>
                </div>
              </div>  
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Horas dobradas:</label>
                    <input type="text" value={this.state.double_paid} name="double_paid" className="form-control" onChange={this.handleChangeHour.bind(this, 'double_paid')} placeholder="" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Valor hora:</label>
                    <input value={this.state.hour_value} disabled="disabled" name="hour_value" className="form-control" onChange={this.handleChange.bind(this, 'hour_value')} placeholder="" />
                  </div>
                </div>
              </div>  
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Total Pago:</label>
                    <input value={this.state.hours_total} disabled="disabled" name="hours_total" className="form-control" onChange={this.handleChange.bind(this, 'hours_total')} placeholder="" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Justificativa de edição:</label>
                    <input value={this.state.justification} required name="justification" className="form-control" onChange={this.handleChange.bind(this, 'justification')} placeholder="Justifique a edição" />
                  </div>
                </div>
              </div> 
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Observação:</label>
                    <input value={this.state.observation} name="observation" className="form-control" onChange={this.handleChange.bind(this, 'observation')} placeholder="Observação" />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Salvar pagamento</button>
                </div>
              </div>
            </form>  
            <hr/>
            <h3>Log de edições do pagamento</h3>
            <hr/>
            <table className="table table-bordered table-hover">
              <thead>
                <tr>
                  <th className="text-center">Id</th>
                  <th className="text-center">Quantidade Horas- Anterior</th>
                  <th className="text-center">Quantidade Horas- Editada</th>
                  <th className="text-center">Quantidade Pnf- Anterior</th>
                  <th className="text-center">Quantidade Pnf- Editada</th>
                  <th className="text-center">Quantidade Horas Dobradas- Anterior</th>
                  <th className="text-center">Quantidade Horas Dobradas- Editada</th>
                  <th className="text-center">Valor total - Anterior</th>
                  <th className="text-center">Valor total - Editado</th>
                  <th className="text-center">Status de Saldo Devedor - Anterior</th>
                  <th className="text-center">Status de Saldo Devedor - Editado</th>
                  <th className="text-center">Usuário</th>
                  <th className="text-center">Justificativa</th>
                  <th className="text-center">Data</th>
                </tr>
              </thead>
              <tbody id="schedule_name-certification-staffs">
                {Object.keys(self.state.payment_editions).map(function(k) {
                  return (
                    <tr>
                      <td className="text-center">{self.state.payment_editions[k].id}</td>
                      <td className="text-center">{self.state.payment_editions[k].last_hours_paid}</td>
                      <td className="text-center">{self.state.payment_editions[k].actual_hours_paid}</td>
                      <td className="text-center">{self.state.payment_editions[k].last_pnf_paid}</td>
                      <td className="text-center">{self.state.payment_editions[k].actual_pnf_paid}</td>
                      <td className="text-center">{self.state.payment_editions[k].last_double_paid}</td>
                      <td className="text-center">{self.state.payment_editions[k].actual_double_paid}</td>
                      <td className="text-center">{self.state.payment_editions[k].last_hours_total}</td>
                      <td className="text-center">{self.state.payment_editions[k].actual_hours_total}</td>
                      <td className="text-center">{self.state.payment_editions[k].last_ignores_debts}</td>
                      <td className="text-center">{self.state.payment_editions[k].actual_ignores_debts}</td>
                      <td className="text-center">{self.state.payment_editions[k].user}</td>
                      <td className="text-center">{self.state.payment_editions[k].justification}</td>
                      <td className="text-center">{self.state.payment_editions[k].date_str}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
            <i className="fa fa-fw fa-close"></i></button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default PaymentHourEditModal;



// WEBPACK FOOTER //
// ./src/Components/TrainingCertificationStaffPayments/PaymentHourEditModal.js